import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { absenceCategories } from "@msuite/utils/absences";
import { AbsenceCategoryForm } from "@/forms/absence-category-form";

export function OrganizationSettingsAbsenceTypes() {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<ContentCard
			title={t("absences.absences_categories")}
			icon={icon("Type")}
			variant="plain"
		>
			{absenceCategories.map((category) => (
				<AbsenceCategoryForm
					key={category}
					category={category}
				/>
			))}
		</ContentCard>
	);
}
